export const calculateRelativeCoordinates = (
  blueprintDescriptionButtonRef,
  modalRef,
) => {
  const buttonRect =
    blueprintDescriptionButtonRef.current.getBoundingClientRect();
  const modalRect = modalRef.current.getBoundingClientRect();

  const relativeCoordinates = {
    x: buttonRect.left - modalRect.left,
    y: buttonRect.top - modalRect.top + buttonRect.height,
  };

  return relativeCoordinates;
};
